import { useEffect, useRef } from "react";
import { loadGoogleMaps } from "../Utils/MapsLoader";

import './../../../style/Vars.css';
import './../../../style/ElementsStyle.css';
import './../../../style/ContainersStyles.css';

export default function TripMapViewer({ origin, destination }) {
  const mapRef = useRef(null);
  const map = useRef(null);
  const markers = useRef([]);

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (!origin?.location && !destination?.location) return;

      try {
        await loadGoogleMaps();
      } catch (e) {
        console.error("Fallo al cargar Google Maps en TripMapViewer:", e);
        return;
      }

      if (!isMounted || !window.google?.maps) return;

      if (!map.current) {
        map.current = new window.google.maps.Map(mapRef.current, {
          center: { lat: 19.4326, lng: -99.1332 },
          zoom: 12,
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
        });
      }

      // Limpiar marcadores previos
      markers.current.forEach((m) => m.setMap(null));
      markers.current = [];

      const bounds = new window.google.maps.LatLngBounds();

      if (origin?.location) {
        const m = new window.google.maps.Marker({
          map: map.current,
          position: origin.location,
          label: "O",
        });
        markers.current.push(m);
        bounds.extend(origin.location);
      }

      if (destination?.location) {
        const m = new window.google.maps.Marker({
          map: map.current,
          position: destination.location,
          label: "D",
        });
        markers.current.push(m);
        bounds.extend(destination.location);
      }

      if (!bounds.isEmpty()) {
        map.current.fitBounds(bounds);
      }
    })();

    return () => {
      isMounted = false;
      markers.current.forEach((m) => m.setMap(null));
      markers.current = [];
      // NO destruimos el map, solo limpiamos marcadores
    };
  }, [origin, destination]);

  return <div className="driver-map-canvas" ref={mapRef} />;
}
